<template>
  <div class="loader">
    <div class="d-flex justify-content-center align-items-center">
      <div class="spinner-border text-white" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Loader",
};
</script>

<style scoped>
.loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}
.loader .spinner-border {
  width: 3rem;
  height: 3rem;
  position: absolute;
  top: 50%;
  left: 50%;
}
</style>